/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Drastic_Tech_Extract_Start_File_LogInputs */



/**
* | output |
* | --- |
* | "-----Extracting closed captioning from {name}-----" |
*
* @param {Drastic_Tech_Extract_Start_File_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_start_file_log = /** @type {((inputs: Drastic_Tech_Extract_Start_File_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Start_File_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`-----Extraction des sous-titres depuis ${i?.name}-----`)
	if (locale === "de") return /** @type {LocalizedString} */ (`-----Extrahieren von Untertiteln aus ${i?.name}-----`)
	if (locale === "it") return /** @type {LocalizedString} */ (`-----Estrazione dei sottotitoli da ${i?.name}-----`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`-----Извлечение субтитров из ${i?.name}-----`)
	if (locale === "es") return /** @type {LocalizedString} */ (`-----Extrayendo subtítulos de ${i?.name}-----`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`-----从${i?.name}提取隐藏式字幕-----`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`-----${i?.name} からクローズドキャプションを抽出しています-----`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`-----${i?.name} से क्लोज्ड कैप्शनिंग निकाली जा रही है-----`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`-----Extraindo legendas ocultas de ${i?.name}-----`)
	return /** @type {LocalizedString} */ (`-----Extracting closed captioning from ${i?.name}-----`)
});